import { blue, brown, grey, red, teal } from "@mui/material/colors";

export const colors = {
	// Browns
	bright: brown[500],
	buttonLink: brown[300], // #AC9C8C
	dialogTitleBg: brown[900],
	headerBg: brown[900],
	linkHighlight: brown[100],
	optionBg: brown[100],
	pageBg: brown[100],
	submitBg: brown[400],

	// Greys
	dark: grey[900],
	dull: grey[500],
	fadedBg: grey[300],
	light: grey[300],
	lightBg: grey[50],
	checkboxFontColor: grey[800],

	// Blues
	checkboxChecked: blue[800],
	listTitleBgcolor: blue[100],
	navActiveBgcolor: blue[50],
	navHighlight: blue[700],
	secondary: blue[800],
	selectedListitemBgColor: blue[100],

	// Teals
	info: teal[600],
	link: teal[200],
	success: teal[500],

	// Reds
	error: red[600],
	errorAlt: red[500],

	// Absolute
	backgroundDefault: "#fff",
	darkest: "#000",
	lightest: "#fff",
} as const;
